import { useCallback } from 'react';
import debounce from 'lodash.debounce';

export default function useDebounce(
  funcToDebounce = () => {},
  timeoutSize = 1500,
  ...deps
) {
  return useCallback(debounce(funcToDebounce, timeoutSize), deps);
}
